"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryCards = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const formatCurrency = (value) => value != null ? `${value.toFixed(2)} EUR` : '-';
const SummaryCards = ({ summary, t }) => {
    const items = [
        { label: t('orders'), value: summary?.salesQuantity },
        { label: t('units'), value: summary?.units },
        { label: t('total'), value: formatCurrency(summary?.totalSales) },
        { label: t('maximum'), value: formatCurrency(summary?.maximum) },
        { label: t('average'), value: formatCurrency(summary?.average) },
    ];
    return ((0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 w-1/2 max-[1007px]:w-full mt-3 shadow-lg rounded-xl p-2 bg-gray-50", children: items.map((item) => ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center justify-center bg-gray-50 rounded-xl", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-xs text-gray-500", children: item.label }), (0, jsx_runtime_1.jsx)("span", { className: "text-sm font-semibold text-gray-800", children: item.value })] }, item.label))) }));
};
exports.SummaryCards = SummaryCards;
